import React from 'react';
import Birth2025 from '../home/Birth2025';

const Birthdance2025 = () => {
  return (
    <div className="relative">
      {/* <AudioPlayer audioSrc={musicFile} /> */}
      <Birth2025 />
    </div>
  );
};

export default Birthdance2025;
